<ng-container *ngIf="certificate$ | async as certificate">
    <div class="panel" *transloco="let t; read: 'certificate'">
        <div class="panel__heading">{{ t("title") }}</div>
        <div class="panel__action-list">
            <a [routerLink]="replacementCardRequestRoute" class="panel__action-list__item panel__action-list__item--order-card">
                <div class="panel__action-list__item__icon"></div>
                <div class="panel__action-list__item__text">{{ t("orderReplacementCard") }}</div>
            </a>

            <a *ngIf="!certificate.id06ConsentDate" [routerLink]="id06ConsentRoute"
               class="panel__action-list__item panel__action-list__item--id06-registration">
                <div class="panel__action-list__item__icon"></div>
                <div class="panel__action-list__item__text">{{ t("id06RegisterConsent")}}</div>
            </a>

            <ng-container *ngIf="data$ | async as data">
                <a *ngIf="data.showSSGInvite" [routerLink]="ssgConsentRoute"
                class="panel__action-list__item panel__action-list__item--ssg-registration">
                    <div class="panel__action-list__item__icon"></div>
                    <div class="panel__action-list__item__text">{{ t("ssgRegisterConsent")}}</div>
                </a>
            </ng-container>
        </div>
    </div>
</ng-container>
